// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"fa349fec","927":"6211289f"}[chunkId] + ".chunk.js";
};